export default function () {
  return {
    users: [],
    roles: {},
    onlineUsers: [],
    usersCurrentPage: 1,
    usersLastPage: 1,
    usersPerPage: 0,
    usersTotal: 0,
    usersLoading: false,
    indexPage: null
  }
}
